import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "page_header"
}
const _hoisted_2 = { class: "mb-0" }
const _hoisted_3 = {
  key: 1,
  class: "formContainer"
}
const _hoisted_4 = {
  filter: "garment.text",
  sort: "garment.text"
}
const _hoisted_5 = {
  filter: "simultaneousAccessNumber",
  sort: "simultaneousAccessNumber"
}
const _hoisted_6 = {
  filter: "expiresOn",
  sort: "expiresOn"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { colspan: "99" }
const _hoisted_10 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_op_table = _resolveComponent("op-table")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.company)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("h1", _hoisted_2, [
            _createTextVNode(_toDisplayString(_ctx.company.companyName) + " - ", 1),
            _createVNode(_component_localized_text, {
              localizedKey: "Licenses",
              text: "Licenses"
            })
          ]),
          _createElementVNode("button", {
            class: "btn btn-primary",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.addLicense()))
          }, [
            _createVNode(_component_localized_text, {
              localizedKey: "Add License",
              text: "Add License"
            })
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.company)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_op_table, {
            class: "table table-striped",
            items: _ctx.company.licenses
          }, {
            default: _withCtx((opData) => [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("td", _hoisted_4, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "Garment",
                      text: "Garment"
                    })
                  ]),
                  _createElementVNode("td", _hoisted_5, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "Simultaneous accesses",
                      text: "Simultaneous accesses"
                    })
                  ]),
                  _createElementVNode("td", _hoisted_6, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "Expires on",
                      text: "Expires on"
                    })
                  ]),
                  _hoisted_7
                ])
              ]),
              _createElementVNode("tbody", null, [
                (opData.data.length == 0)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_8, [
                      _createElementVNode("td", _hoisted_9, [
                        _createVNode(_component_localized_text, {
                          localizedKey: "No Elements Found",
                          text: "No Elements Found"
                        })
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((opData.data as OM.GarmentLicense[]), (item, i) => {
                  return (_openBlock(), _createElementBlock("tr", { key: i }, [
                    _createElementVNode("td", null, _toDisplayString(item.garment.text), 1),
                    _createElementVNode("td", null, _toDisplayString(item.simultaneousAccessNumber), 1),
                    _createElementVNode("td", null, _toDisplayString(_ctx.$filters.date(item.expiresOn)), 1),
                    _createElementVNode("td", null, [
                      _createElementVNode("button", {
                        class: "btn btn-primary",
                        onClick: ($event: any) => (_ctx.removeLicense(item))
                      }, "Rimuovi", 8, _hoisted_10)
                    ])
                  ]))
                }), 128))
              ])
            ]),
            _: 1
          }, 8, ["items"])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}